import addMonths from "date-fns/addMonths"
import format from "date-fns/format"

export const dateValid = (date) => {
    if (!/^\d{2}\.\d{2}\.\d{4}$/.test(date)) return false

    // Parse the date parts to integers
    const parts = date.split(".")
    const day = parseInt(parts[0], 10)
    const month = parseInt(parts[1], 10)
    const year = parseInt(parts[2], 10)

    // Check the ranges of month and year
    if (year < 1000 || year > 3000 || month === 0 || month > 12)
        return false

    const monthLength = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];

    // Adjust for leap years
    if (year % 400 === 0 || (year % 100 !== 0 && year % 4 === 0))
        monthLength[1] = 29;

    // Check the range of the day
    return day > 0 && day <= monthLength[month - 1]
}

export const MAX_PDF_REPORT_PERIOD_MONTHS = 6

export const MAX_PDF_REPORT_PERIOD_ERROR = "Максимальный период формирования pdf-отчётов равен 6 месяцам"

export const getLastPeriodDate = (start, months) => {
    if (!start) return null

    return format(addMonths(new Date(start), months), "yyyy-MM-dd")
}

export const isPeriodInMonthsValid = (start, end, months) => {
    if (!start || !end || !months) return true

    const lastDate = getLastPeriodDate(start, months)

    return new Date(end) <= new Date(lastDate)
}